import * as Sentry from '@sentry/browser';

const reportUnhandledRejection = (event: PromiseRejectionEvent) => {
  const { reason } = event;
  const error = reason instanceof Error ? reason : new Error(String(reason));

  Sentry.withScope(scope => {
    scope.setTag('errorType', 'unhandledRejection');
    Sentry.captureException(error);
  });
};

const initUnhandledRejectionHandler = () => {
  window.addEventListener('unhandledrejection', reportUnhandledRejection);
};

export { reportUnhandledRejection, initUnhandledRejectionHandler };
